export const WORK_DIR_NAME = 'project';
export const WORK_DIR = '';
export const MODIFICATIONS_TAG_NAME = 'versoriFileModifications';
export const VERSORI_FLOW_FILE_NAME = 'versori-flow.json';
export const INTEGRATION_FILE_NAME = 'integration.ts';
export const GOOGLE_ANALYTICS_ID = 'G-NK3VKENWVQ';
export const ARCHITECTURAL_DIAGRAM_FILE_NAME = 'architectural_diagram.md';
export const INTEGRATION_VARIABLES_FILE_NAME = 'integration-variables-schema.json';
export const DEPLOY_MESSAGE = 'Deploy my Integration';
export const FINAL_REPORT_MESSAGE = 'Generate a solution document from my research';
export const REGENERATE_FINAL_REPORT_MESSAGE = 'Re-generate the solution document from my research';
export const TRANSFORMATION_MAPPING_FILE_NAME = 'transformation_mapping_visualisation.md';
export const GENERATE_WORKFLOWS_MESSAGE = 'Generate workflows based on the research findings and documents provided.';
